import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { IProject } from '../../../shared/models/project.model';
import { IEnclosure } from '../../../shared/models/enclosure.model';
import { INotification } from '../../../shared/models/notification.model';
import { MobileSideMenuComponent } from '../mobile-side-menu/mobile-side-menu.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-sub-header',
    templateUrl: './sub-header.component.html',
    styleUrls: ['./sub-header.component.scss'],
    standalone: false
})
export class SubHeaderComponent {

  openedEnclosureList = false;

  @Input() project: IProject;
  @Input() imagePath: string;
  @Input() enclosures: IEnclosure[];
  @Input() selectedId: number;
  @Input() currentEnclosure: IEnclosure;
  @Input() isHomePage = false;
  @Input() projectsCount: number;
  @Input() sharedProjectsCount: number;
  @Input() archivedProjectsCount: number;
  @Input() sharedProjectsPendingCount: number;
  @Input() notifications: INotification[];
  @Input() userIsCompanyAdmin: boolean;
  @Input() companyProjectsAssigned: number;
  @Input() companyProjectsUnassigned: number;
  @Input() myProjectsNotificationDot: boolean;

  @Output() private enclosureSelect = new EventEmitter<IEnclosure>();
  @Output() removeNotification = new EventEmitter<string>();
  @Output() clearNotifications = new EventEmitter();

  selectEnclosure(enclosure: IEnclosure) {
    this.enclosureSelect.emit(enclosure);
  }

  toggleEnclosureList() {
    if (this.enclosures?.length > 1) {
      this.openedEnclosureList = !this.openedEnclosureList;
    }
  }

  removeFromNotifications(notificationUUID: string) {
    this.removeNotification.emit(notificationUUID);
  }

  clearAllNotifications() {
    this.clearNotifications.emit();
  }

  trackByFn(index, _) {
    return index;
  }

  toggleProjectsMenu(mobileSideMenu:MobileSideMenuComponent) {
    mobileSideMenu.toggleMobileMenu();
  }

  closeMobileMenu(mobileSideMenu:MobileSideMenuComponent) {
    mobileSideMenu.close();
  }
}
